<template>
    <router-link
        :to="{ name: 'dashboard-folder', params: { folder: folder._id } }"
        class="lb-folder-box"
        @mouseover.native="showMenu = true"
        @mouseleave.native="showMenu = false"
    >
        <figure class="lb-folder-box-content">
            <p class="lb-folder-box-title">
                <span class="icon-text mr-2">
                    <span class="icon pt-1">
                        <i class="mdi mdi-24px mdi-folder-outline"></i>
                    </span>
                </span>
                {{ folder.name }}
            </p>

            <!--div class="level">
        <div class="level-left">
          <div class="level-item">
            <span class="icon-text lb-folder-box-title">
              <span class="icon">
                <i class="fas fa-folder"></i>
              </span>
            </span>
          </div>
        </div>
        <div class="level-right is-shrinkable">
          <div class="level-item is-shrinkable">
            <span class="lb-folder-box-title"> {{ folder.name }}</span>
          </div>
        </div>
      </div-->

            <div v-if="showMenu && isOwner" class="lb-folder-box-dropdown pt-2">
                <span class="icon is-small dropdown-trigger mt-1">
                    <i
                        class="mdi mdi-24px mdi-dots-vertical"
                        aria-hidden="true"
                    />
                </span>
                <div class="dropdown-menu" role="menu">
                    <div class="dropdown-content">
                        <a
                            v-t="'Folders.dropdown_option_edit'"
                            class="dropdown-item has-cursor-pointer has-text-left"
                            @click.stop.prevent="$emit('edit', folder)"
                        />
                        <a
                            v-t="'Folders.dropdown_option_delete'"
                            class="dropdown-item has-cursor-pointer has-text-left"
                            @click.stop.prevent="$emit('delete', folder)"
                        />
                    </div>
                </div>
            </div>
        </figure>
    </router-link>
</template>

<script>
export default {
    props: {
        folder: {
            type: Object,
            required: true,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            showMenu: false,
        };
    },
    computed: {
        isOwner() {
            return this.folder.owner.owner == this.$store.getters.user.owner;
        },
    },
};
</script>

<style scoped> 

.dropdown-item:hover{
    cursor: pointer;
    background-color: var(--eduloc-grey-light);
}
.dropdown-content{
    padding:0;
    border-radius: 0;
}
</style>
